import { getOrgVideos } from '@/api/open'
import infiniteScroll from './Scroll'

export default {
    directives: { infiniteScroll },
    components: {
    },
    model: {
        prop: 'ids',
        event: 'change'
    },
    props: {
        advertiserId: {},
        ids: { type: Array, default: () => [] },
        maxNum: {},
        media: {},
        outId: {},
    },
    data () {
        return {
            loading: false,
            finished: false,
            busy: false,
            coverLoading: false,
            videos: [],
            currentIds: [],
            page: 1,
            show: false,
            currentVideo: null,
            queryParam: {},
            orgMaterialIds: '',
            video_total: null,
            // 素材类型 / 评估类型 选项（组织素材接口 filtering 字段）
            imageModeOptions: [
                { value: 'CREATIVE_IMAGE_MODE_VIDEO', label: '横版视频' },
                { value: 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL', label: '竖版视频' }
            ],
            evaluateTypeOptions: [
                { value: 'FIRST_PUBLISH', label: '首发' },
                { value: 'HIGH_QUALITY', label: '优质' }
            ],
            // 悬浮预览卡片相关
            previewVisible: false,
            previewCardStyle: {},
            previewTimer: null,
            hideTimer: null,
        }
    },
    beforeDestroy() {
        // 组件销毁时，移除全局的键盘事件监听器
        window.removeEventListener('keydown', this.handleKeyDown);
        this.removeScrollListener();
        if (this.previewTimer) clearTimeout(this.previewTimer);
        if (this.hideTimer) clearTimeout(this.hideTimer);
        this.removePreviewCard();
    },
    computed: {},
    watch: {
        show(value) {
            if (!value) {
                this.videos = []
                this.finished = false
                this.page = 1
                this.previewVisible = false
                this.currentVideo = null
                return false
            }
            this.getData()
        },
        // 弹层多行素材ID输入 → 同步到 queryParam.material_id（换行转逗号）
        orgMaterialIds(val) {
            this.queryParam.material_id = val ? val.replace(/\n/g, ',') : ''
        },
    },
    mounted () {
        window.addEventListener('keydown', this.handleKeyDown);
        this.currentIds = Object.assign([], this.ids)
        this.maxNum = this.num || this.maxNum
        this.$nextTick(() => {
            const wrapper = this.$el.querySelector('.org-video-select-wrapper')
            if (wrapper) {
                wrapper.addEventListener('scroll', this.onScrollHidePreview)
            }
            this.appendToBody()
        })
    },
    methods: {
        handleKeyDown(event) {
            if (event.key === 'Enter') {
                this.search()
            }
        },
        search() {
            this.videos = []
            this.page = 1
            this.getData()
        },
        // 输入框逗号分隔输入 → 同步到弹层多行（逗号转换行）
        changeMaterialIds() {
            const v = (this.queryParam.material_id || '').replace(/,/g, '\n')
            if (v !== this.orgMaterialIds) {
                this.orgMaterialIds = v
            }
        },
        resetSearch() {
            this.videos = []
            this.page = 1
            this.queryParam = {}
            this.orgMaterialIds = ''
            this.getData()
        },
        handleInfiniteOnLoad() {
            if (this.finished || this.loading) {
                return false
            }
            this.getData()
        },
        getData() {
            let materialIds = [];
            this.currentIds.forEach(item => {
                materialIds.push(item.material_id);
            });

            const json = {
                page: this.page,
                page_size: 100,
                name: this.queryParam.name,
                current_material_ids: materialIds,
            }
            // 素材ID：支持多个用逗号分隔，必须是数字（保持字符串传递，防止过长ID精度丢失），否则报错
            if (this.queryParam.material_id !== undefined && this.queryParam.material_id !== '' && this.queryParam.material_id !== null) {
                const idStr = String(this.queryParam.material_id)
                const idParts = idStr.split(',').map(s => s.trim()).filter(s => s !== '')
                if (idParts.length === 0) {
                    json['material_ids'] = []
                } else {
                    const normalized = []
                    let valid = true
                    for (const part of idParts) {
                        if (!/^\d+$/.test(part)) {
                            valid = false
                            break
                        }
                        // 以字符串传递，避免超长ID(如 7676895108734714000)被 Number 截断
                        normalized.push(String(part))
                    }
                    if (!valid) {
                        return this.$message.error('素材ID必须为数字，多个ID请用英文逗号分隔')
                    }
                    json['material_ids'] = normalized
                }
            }
            if (this.queryParam.image_modes && this.queryParam.image_modes.length) {
                json.image_modes = this.queryParam.image_modes
            }
            if (this.queryParam.evaluate_types && this.queryParam.evaluate_types.length) {
                json.evaluate_types = this.queryParam.evaluate_types
            }
            if (this.outId) {
                json.out_id = this.outId
            } else {
                json.advertiser_id = this.advertiserId
            }

            this.loading = true
            getOrgVideos(json).then(res => {
                this.page++
                this.loading = false
                this.video_total = res.data.video_total
                if (!res.data.has_more || res.data.list.length === 0) {
                    this.finished = true
                }
                this.videos = this.videos.concat(res.data.list)
            }).finally(() => {
                this.loading = false
            })
        },
        // 判断素材宽高比是否匹配横版16:9/竖版9:16（各上下浮动0.05，与后端素材选中逻辑一致）
        isValidRatio(width, height) {
            if (!width || !height) {
                return false;
            }
            const epsilon = 0.05;
            const landscapeRatio = 16 / 9; // 横版基础比例 1.7778
            const targetAspectRatio = 9 / 16; // 竖版基础比例 0.5625
            const ratio = width / height;
            return Math.abs(ratio - landscapeRatio) <= epsilon || Math.abs(ratio - targetAspectRatio) <= epsilon;
        },
        changeVideoId(video) {
            for (const key in this.currentIds) {
                if (this.currentIds[key].id === video.id) {
                    delete this.currentIds[key]
                    this.currentIds = this.currentIds.filter(v => {
                        return v !== null
                    })
                    return true
                }
            }
            if (this.currentIds.length >= this.maxNum) {
                return this.$message.error(`当前最多支持选择${this.maxNum}个视频`)
            }

            this.currentIds.push(video)

            // 巨量过滤掉尺寸不合适的视频（横版16:9/竖版9:16，各上下浮动0.05）
            this.currentIds = this.currentIds.filter(item => this.isValidRatio(item.width, item.height));
        },
        videoSelected(video) {
            let ids = this.currentIds.map(item => item.id);
            return ids.includes(video.id);
        },
        clearSelected () {
            this.currentIds = []
            this.complete()
        },
        preview(video, event) {
            if (this.hideTimer) {
                clearTimeout(this.hideTimer)
                this.hideTimer = null
            }
            if (this.previewTimer) clearTimeout(this.previewTimer)
            const target = event.currentTarget
            this.previewTimer = setTimeout(() => {
                if (!target) return
                this.currentVideo = video
                this.calculatePosition(target)
                this.previewVisible = true
            }, 200)
        },
        hidePreview() {
            if (this.previewTimer) {
                clearTimeout(this.previewTimer)
                this.previewTimer = null
            }
            this.hideTimer = setTimeout(() => {
                this.previewVisible = false
                this.currentVideo = null
            }, 200)
        },
        onCardMouseEnter() {
            if (this.hideTimer) {
                clearTimeout(this.hideTimer)
                this.hideTimer = null
            }
        },
        onCardMouseLeave() {
            this.hidePreview()
        },
        onScrollHidePreview() {
            if (this.previewVisible) {
                this.previewVisible = false
                this.currentVideo = null
            }
        },
        removeScrollListener() {
            try {
                const wrapper = this.$el && this.$el.querySelector('.org-video-select-wrapper')
                if (wrapper) {
                    wrapper.removeEventListener('scroll', this.onScrollHidePreview)
                }
            } catch (e) {
                // ignore
            }
        },
        appendToBody() {
            const card = this.$refs.previewCard
            if (card && card.parentNode !== document.body) {
                document.body.appendChild(card)
            }
        },
        removePreviewCard() {
            const card = this.$refs.previewCard
            if (card && card.parentNode) {
                card.parentNode.removeChild(card)
            }
        },
        calculatePosition(el) {
            const rect = el.getBoundingClientRect()
            const cardWidth = 320
            const gap = 10
            const winH = window.innerHeight

            let cardHeight = 569
            if (this.currentVideo && this.currentVideo.ratio === 1.7778) {
                cardHeight = 180
            }
            cardHeight = Math.min(cardHeight, winH - gap * 2)

            let left = rect.right + gap
            let top = Math.max(gap, rect.top)

            if (left + cardWidth > window.innerWidth - gap) {
                left = Math.max(gap, rect.left - cardWidth - gap)
            }

            if (top + cardHeight > winH - gap) {
                top = winH - cardHeight - gap
            }
            if (top < gap) {
                top = gap
            }

            this.previewCardStyle = {
                left: left + 'px',
                top: top + 'px',
            }
        },
        close() {
            this.show = false
            this.currentIds = Object.assign([], this.ids)
        },
        complete() {
            this.$emit('change', Object.assign([], this.currentIds))
            this.show = false
        },
        selectAll () {
            for (const key in this.videos) {
                let thisVideo = this.videos[key]
                if (key < this.maxNum) {
                    if (!this.videoSelected(thisVideo)) {
                        if (this.isValidRatio(thisVideo.width, thisVideo.height)) {
                            this.currentIds.push(thisVideo)
                        }
                    }
                }
            }
            this.currentIds = this.currentIds.filter(item => this.isValidRatio(item.width, item.height));
        },
    }
}